<template>
  <div>
    <v-container style="padding-top: 80px;">
      <v-row justify="center">
        <v-col lg="6">
          <v-card flat class="bcg">
            <div class="pa-10">
              <form action="#" @submit.prevent="login">
                <h2>Lost Password Change</h2>
                <span class="public-text">Type your new password</span>

                <div class="register mt-6">
                  <v-text-field
                    v-model="password"
                    class="register mt-3"
                    label="Password"
                    background-color="#b6c1cb"
                    color="#4dbac0"
                    type="password"
                    light
                    filled
                  ></v-text-field>
                  <v-text-field
                    v-model="passwordConfirm"
                    class="register mt-3"
                    label="Confirm password"
                    background-color="#b6c1cb"
                    color="#4dbac0"
                    type="password"
                    light
                    filled
                  ></v-text-field>
                </div>
                <div class="errors">
                <li v-for="(error, index) in errors" :key="index">{{error}}</li>
              </div>
                <div align="right">
                  <v-btn type="submit" large color="success" class="mt-3">
                    <v-icon>forward</v-icon>
                    <span>Process</span>
                  </v-btn>
                </div>
              </form>
            </div>
          </v-card>
          <div lg="12" align="center" class="mt-4">
            Contact support?
          </div>
        </v-col>
      </v-row>
    </v-container>

    <Footer />
  </div>
</template>

<script>
export default {
  name: "login",
  props: ['token'],
  components: {},
  data() {
    return {
      loading: false,
      passwordConfirm: "",
      password: "",
      errors: new Array()
    };
  },
  methods: {
    login() {
      this.errors = [];

      if (this.passwordConfirm != this.password) {
        this.errors.push("New passwords do not match");
      }

      if (this.password < 8) {
        this.errors.push("New passwords at least 8 characters long");
      }

      if (this.errors.length == 0) {
        this.$store
          .dispatch("recoverPassword", {
            token: this.token,
            password: this.password
          })
          .then(() => {
            this.$router.push("/login");
          })
          .catch(() => {
            this.errors.push("Token expired")
          });
      }
    }
  }
};
</script>

<style scoped>
.public-text {
  color: #b6c1ca !important;
}
.title-small {
  font-family: "Roboto";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 20px;
}
.bcg {
  background-image: url(../assets/img/logo-cropped.svg);
  background-size: contain;
}
</style>